import React, { Component } from "react";

import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";

import { renderErrorMessage } from "../../helper/user_helper";

let strings = new LocalizedStrings({ en });

class Comment extends Component {
  state = { userComment: "" };
  render() {
    return <div className="comment_only">{this.renderSendMessage()}</div>;
  }
  renderSendMessage() {
    if (this.props.user === null) {
      return <div />;
    }
    return (
      <React.Fragment>
        {renderErrorMessage(this.props.errors)}
        <input
          placeholder={strings.add_comment}
          type="text"
          onChange={this.handleChangeComment}
          value={this.props.comment}
        />
        <label className="title">{this.props.user.username}</label>
      </React.Fragment>
    );
  }
  handleChangeComment = event => {
    //this.setState({ userComment: event.target.value });
    this.props.commentChanged(event.target.value);
  };
}

export default Comment;



// WEBPACK FOOTER //
// ./src/components/comments/comment.jsx